module.exports = "/assets/data/fcb1e418743ee3402cfd898d769d29bf-B64.data.json";